// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rowdies:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Rowdies, lato;
}

.menu-header-bg {
  height: 180px;
  width: 350px;
  background: #7590d6;
  background: linear-gradient(90deg, #f24b4b 0%, #990505 100%);
  box-shadow: 0px 1px 10px rgba(98, 140, 255, 0.5);
  transform: rotate(-15deg);
  border-radius: 10px 10px 10px 50px;
  margin-left: -18px;
  margin-top: -50px;
  margin-bottom: 60px;
}

.header-content {
  position: absolute;
  top: 30px;
  left: 15px;
  display: flex;
  align-items: center;
}
.header-content img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 7px solid #de1f1f;
}
.header-content h2 {
  font-weight: 300;
  color: #fff;
}
.header-content p {
  font-size: 12px;
  color: #e4e4e4;
  font-weight: 100;
  letter-spacing: 0.4px;
}

.action-button {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.action-button ion-button {
  text-transform: capitalize;
  font-weight: 300;
  --background: #de1f1f;
  --border-radius: 7px;
  --box-shadow: none;
}
.action-button ion-button ion-icon {
  margin-right: 1px;
}

.menu-items {
  margin: 0px;
}
.menu-items ion-icon {
  margin-right: 15px;
  color: #f44336;
  font-size: 18px;
}
.menu-items ion-item {
  padding-left: 10px;
  margin-bottom: 0px;
}
.menu-items .active {
  border-left: 5px solid;
  color: #628cff;
  padding-left: 15px;
}
.menu-items .active ion-icon {
  color: #628cff;
}

.menu-head {
  padding: 20px 20px 15px 20px;
  border-bottom: 1px solid #f3f2f2;
  background: #f9f9f9;
  margin-bottom: 15px;
}
.menu-head img {
  max-width: 150px;
}

.hlogo {
  width: 80px;
  height: auto;
  max-height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/toolbar/toolbar.component.scss"],"names":[],"mappings":"AAEA;EACE,0BAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,4DAAA;EACA,gDAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,WAAA;AADJ;AAIE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAKE;EACE,0BAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;AAKI;EACE,iBAAA;AAHN;;AAQA;EACE,WAAA;AALF;AAOE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AALJ;AAQE;EACM,kBAAA;EACJ,kBAAA;AANJ;AASE;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;AAPJ;AASI;EACE,cAAA;AAPN;;AAYA;EACI,4BAAA;EACA,gCAAA;EACA,mBAAA;EACI,mBAAA;AATR;AAWI;EACI,gBAAA;AATR;;AAaA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAVF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rowdies:wght@300&display=swap');\r\n\r\n* {\r\n  font-family: Rowdies, lato;\r\n}\r\n\r\n.menu-header-bg {\r\n  height: 180px;\r\n  width: 350px;\r\n  background: #7590d6;\r\n  background: linear-gradient(90deg, #f24b4b 0%, #990505 100%);\r\n  box-shadow: 0px 1px 10px rgba(98, 140, 255, 0.5);\r\n  transform: rotate(-15deg);\r\n  border-radius: 10px 10px 10px 50px;\r\n  margin-left: -18px;\r\n  margin-top: -50px;\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.header-content {\r\n  position: absolute;\r\n  top: 30px;\r\n  left: 15px;\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  img {\r\n    width: 80px;\r\n    height: 80px;\r\n    border-radius: 50%;\r\n    border: 7px solid #de1f1f;\r\n  }\r\n\r\n  h2 {\r\n    font-weight: 300;\r\n    color: #fff;\r\n  }\r\n\r\n  p {\r\n    font-size: 12px;\r\n    color: #e4e4e4;\r\n    font-weight: 100;\r\n    letter-spacing: 0.4px;\r\n  }\r\n}\r\n\r\n.action-button {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n\r\n  ion-button {\r\n    text-transform: capitalize;\r\n    font-weight: 300;\r\n    --background: #de1f1f;\r\n    --border-radius: 7px;\r\n    --box-shadow: none;\r\n\r\n    ion-icon {\r\n      margin-right: 1px;\r\n    }\r\n  }\r\n}\r\n\r\n.menu-items {\r\n  margin: 0px;\r\n\r\n  ion-icon {\r\n    margin-right: 15px;\r\n    color: #f44336;\r\n    font-size: 18px;\r\n  }\r\n\r\n  ion-item {\r\n        padding-left: 10px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .active {\r\n    border-left: 5px solid;\r\n    color: #628cff;\r\n    padding-left: 15px;\r\n\r\n    ion-icon {\r\n      color: #628cff;\r\n    }\r\n  }\r\n}\r\n\r\n.menu-head {\r\n    padding: 20px 20px 15px 20px;\r\n    border-bottom: 1px solid #f3f2f2;\r\n    background: #f9f9f9;\r\n        margin-bottom: 15px;\r\n\r\n    img {\r\n        max-width: 150px;\r\n    }\r\n}\r\n\r\n.hlogo{\r\n  width: 80px;\r\n  height: auto;\r\n  max-height: 40px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
